import React from "react";
import { VIDEO_CONSTRAINTS } from "../constants/captureSettings";

// Lớp phủ lên hình xem trước: khung cắt thật + lưới 1/3.
//
// Vì sao cần cái này — đây là bản vá cho một lỗi thật, không phải trang trí:
//
//   Webcam    953 × 599  → tỉ lệ 1.591
//   Ô ảnh     950 × 555  → tỉ lệ 1.712   (khung 1, 2, 3)
//   Ô ảnh     888 × 595  → tỉ lệ 1.492   (khung 4)
//
// `coverTransform()` phóng ảnh cho phủ kín ô rồi cắt bỏ phần thừa. Với khung
// 1/2/3 là mất ~7% chiều cao (trên và dưới), với khung 4 là mất ~6% chiều rộng
// (trái và phải). Người dùng nhìn hình xem trước thấy đủ đầu, chụp xong mới
// phát hiện bị cụt tóc. Khung này vẽ đúng phần sẽ được giữ lại và làm tối phần
// sẽ bị cắt bỏ, nên nhìn trước là biết.
export default function CropGuide({ slot }) {
    if (!slot) return null;

    const slotRatio = slot.w / slot.h;
    const camRatio = VIDEO_CONSTRAINTS.width / VIDEO_CONSTRAINTS.height;

    // Ô ảnh "bè" hơn webcam → phải cắt trên–dưới; ngược lại → cắt trái–phải.
    const keep =
        slotRatio > camRatio
            ? { width: "100%", height: `${(camRatio / slotRatio) * 100}%` }
            : { width: `${(slotRatio / camRatio) * 100}%`, height: "100%" };

    return (
        <div style={wrap}>
            <div style={{ ...keepBox, ...keep }}>
                {/* Lưới 1/3 nằm TRONG phần được giữ lại, không tính phần bị cắt —
                    nếu chia ba trên cả khung xem trước thì bố cục sẽ lệch. */}
                {THIRDS.map(p => (
                    <div key={`v${p}`} style={{ ...gridLine, left: `${p}%`, top: 0, bottom: 0, width: 1 }} />
                ))}
                {THIRDS.map(p => (
                    <div key={`h${p}`} style={{ ...gridLine, top: `${p}%`, left: 0, right: 0, height: 1 }} />
                ))}
            </div>
        </div>
    );
}

const THIRDS = [33.333, 66.667];

const wrap = {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none"
};

const keepBox = {
    position: "relative",
    boxSizing: "border-box",
    border: "2px dashed rgba(255,255,255,0.9)",
    // Làm tối toàn bộ phần nằm ngoài khung giữ lại. Vệt đổ bóng lan rất rộng nên
    // thẻ bọc hình xem trước phải có overflow: hidden để cắt gọn phần thừa.
    boxShadow: "0 0 0 9999px rgba(0,0,0,0.45)"
};

const gridLine = {
    position: "absolute",
    background: "rgba(255,255,255,0.75)",
    // Vạch trắng trơn biến mất trên nền sáng (áo trắng, tường trắng, ảnh cháy
    // sáng). Viền tối mảnh quanh vạch giúp nhìn rõ trên mọi nền.
    boxShadow: "0 0 0 1px rgba(0,0,0,0.35)"
};
